<template>
  <div class="mt-4 pr-0 pl-0 pt-2 border_all" style="border: thin solid rgba(0,0,0,.12)">
    <v-toolbar elevation="0">
      <v-text-field
          flat
          solo
          clearable
          prepend-icon="search"
          placeholder="Type something"
          v-model="opsitable.search"
          hide-details
          class=""
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn small elevation="0" class="ml-2" color="primary" @click.native="getCategory(opsitable)">
        <v-icon dark>refresh</v-icon>Refresh
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-data-table
        dense
        sort-by="id"
        :sort-desc="sortdes"
        :headers="headers"
        :search="search"
        :items="categories"
        class="elevation-0"
        item-key="id"
        :options.sync="opsitable"
        :server-items-length="totalcategory"
        :loading="loading"
        @update:options="getCategory(opsitable)">
      <template v-slot:item.image="{ item }">
        <v-img width="36" class="ma-4" :src="item.image"></v-img>
      </template>
      <template v-slot:item.updateat="{ item }">
        {{formatDate(item.updateat)}}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'Category',
  data: () => ({
    search: '',
    sortdes: [true],
    opsitable: {
      search: '',
      itemsPerPage: 100,
      page: 1,
      status: '',
      sortBy: ['id']
    },
    headers: [
      {
        text: 'Id',
        value: 'id'
      },
      {
        text: 'Logo',
        value: 'image'
      },
      {
        text: 'Category',
        value: 'name'
      },
      {
        text: 'Update',
        value: 'updateat'
      }
    ]
  }),
  computed: {
    ...mapState('AdminProducts', ['loading', 'dialogcategory', 'categories', 'totalcategory'])
  },
  methods: {
    ...mapActions('AdminProducts', ['getCategory']),
    formatDate (value) {
      return moment(value).add(0, 'hours').format('YYYY/MM/DD HH:mm:ss')
    },
    statusText (val) {
      if (parseInt(val) === 1) {
        return 'Enable'
      } else {
        return 'Disable'
      }
    },
    colorStatus (val) {
      if (parseInt(val) === 0) {
        return 'red'
      }
      if (parseInt(val) === 1) {
        return 'green'
      }
    }
  }
}
</script>

<style scoped>

</style>
